import BaseNodeModel from "../BaseNodeModel";

export default class LoopEscalationNodeModel extends BaseNodeModel {
    /**
     * Loop Escalation node model
     * @module LoopEscalationNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = "Loop Escalation";
        this.props.colorClass = "yellow";
        this.props.iconClass = "refresh-cw";
        this.DEFAULT_COLOR_CLASS = "yellow";
        this.applyProps(props);
    }

    setConfig(key, value) {
        super.setConfig(key, value);
    }

    getConfigViews() {
        return [
            ...this.getConfigViewNameField(),
            ...[
                { type: "Textarea", label: this.getPropLabel("description"), key: "description", value: "Transition caller into an interacting with an agent without the IVA application terminating"},
                { type: "ItemList", label: this.getPropLabel("variables"), key: "inputs", view: "argument" },
                { type: "Textarea", label: this.getPropLabel("note"), key: "note" }
            ]
        ];
    }
}
